import { GlobalContext } from 'Global/Context/GlobalContextProvider';
// import { SaveAppointment } from "Routes/Public/GetNewTurn/Adapters/SaveAppointment";
import Cookies from 'js-cookie';
import { useContext, useMemo } from 'react';

const useCheckOnLoginOperations = () => {
  const saveTurn =
    sessionStorage.getItem('saveTurn') &&
    JSON.parse(sessionStorage.getItem('saveTurn'));
  const user =
    Cookies.get('user') && JSON.parse(Cookies.get('user'));
  const navigate = useContext(GlobalContext)?.navigate;

  useMemo(() => {
    if (saveTurn) {
      if (user?.IdPatient) {
        SaveAppointment(
          {
            idPatient: user?.IdPatient,
            idNobat: Number(saveTurn?.Id),
          },
          navigate
        );
      }
    }
  }, [JSON.stringify(saveTurn), JSON.stringify(user)]);
};

export default useCheckOnLoginOperations;
